import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {Apartment} from '../../shared/models/apartment.model';
import {ApiConfigService} from './api.config.service';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';

@Injectable({providedIn: 'root'})
export class ApartmentService {
  constructor(private http: HttpClient, private hoomvipStorage: HoomvipStorage, private apiConfigService: ApiConfigService, private cache: HttpCacheService) {
  }

  getApartment(): Observable<Apartment> {
    const apartmentId = this.hoomvipStorage.getApartment();
    if (apartmentId === null) {
      return throwError(() => new Error('Apartment ID is required'));
    }
    const key = `ApartmentService:GET:${this.apiConfigService.getApartmentUrl(apartmentId)}`;
    return this.cache.getOrSet<Apartment>(
      key,
      HTTP_CACHE_TTL_MS.REGULAR,
      () => this.http.get<Apartment>(this.apiConfigService.getApartmentUrl(apartmentId))
    );
  }
}
